import type { FeatureFlags } from './index';
import type { RouteRecordRaw } from 'vue-router';

export interface ClientConfig {
  id: string;
  name: string;
  features: Partial<FeatureFlags>;
  theme?: string;
  routes?: RouteRecordRaw[];
  defaultOrigin?: string;
  defaultDestination?: string;
  // ISO alpha-2 codes this client is contracted to support as origins. When set,
  // the Origin picker is limited to these countries instead of the profile list.
  allowedOrigins?: string[];
  logoUrl?: string;
}

export interface ClientMapping {
  [hostname: string]: string;
}

// Default feature flags for all clients
export const defaultFeatures: FeatureFlags = {
  showUserDetails: true,
  showRules: false,
  showLanguageOptions: true,
  showExportCountry: true,
  showHarmonizedSchedule: false,
  showTariffSchedule: true,
  showExportSchedule: true,
  showNotes: true,
  showCommentary: false,
  showTariffEligibility: true,
  showImportExportControls: true,
  showDocumentaryReqs: true,
  showGenerateCertificates: true,
  showCaCodes: false,
  enableKeywordSearch: true,
  disableDestCountryInput: false,
  disableExpCountryInput: false,
  disableOriginCountryInput: false,
  disableQueryBoxInput: false,
  disableInteractionsClick: false,
  useHSCodeBigClick: false,
  useTariffScheduleClick: true,
  assumedInteractionsDefaultExpandedPosition: false,
  knownInteractionsDefaultExpandedPosition: true,
  tSchedule_showVat: false,
  tSchedule_showExcise: false,
  tSchedule_showLevy: false,
  tSchedule_fullExpand: false,
  debugOptions: false,
  _showLoadingAnimation: false,
  showInputSections: true,
  showQueryBox: true,
  showItemBody: true,
};

